import React from 'react';
export function GaugeIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M17.338 12.928a5.285 5.285 0 10-10.532 0H4.8a7.285 7.285 0 1114.543 0h-2.006z"
  }), React.createElement("path", {
    d: "M4.876 18.213a8.928 8.928 0 1114.393 0h-3.12a3.856 3.856 0 01-.321 2h4.44v-.057A10.886 10.886 0 0023 12.928C23 6.893 18.107 2 12.072 2 6.037 2 1.144 6.893 1.144 12.928c0 2.771 1.032 5.302 2.732 7.229v.056h4.896a3.856 3.856 0 01-.322-2H4.876z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.46 12.751l-1.37 7.95-2.4-.605 2.57-7.648 1.2.303z"
  }), React.createElement("path", {
    d: "M14.01 20.25a2.05 2.05 0 11-3.715-1.733 2.05 2.05 0 013.714 1.732z"
  }));
}